import { create } from "zustand";

interface ModalState {
  isModalOpen: boolean;
  setModalOpen: (isOpen: boolean) => void;
  isActionsLoading: boolean;
  setActionsLoading: (isOpen: boolean) => void;
  isRoleModalOpen: boolean;
  setRoleModalOpen: (isOpen: boolean) => void;
  isPasswordResetModalOpen: boolean;
  setPasswordResetModalOpen: (isOpen: boolean) => void;
  roleEmail: string | null;
  setRoleEmail: (role: string | null) => void;
  role: string | null;
  setRole: (email: string | null) => void;
  roleReset: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  isModalOpen: false,
  setModalOpen: (isOpen) => set({ isModalOpen: isOpen }),
  isActionsLoading: false,
  setActionsLoading: (isOpen) => set({ isActionsLoading: isOpen }),
  isRoleModalOpen: false,
  setRoleModalOpen: (isOpen) => set({ isRoleModalOpen: isOpen }),
  isPasswordResetModalOpen: false,
  setPasswordResetModalOpen: (isOpen) =>
    set({ isPasswordResetModalOpen: isOpen }),
  roleEmail: null,
  setRoleEmail: (email) => set({ roleEmail: email }),
  role: null,
  setRole: (role) => {
    const oppRole = role === "admin" ? "editor" : "admin";
    set({ role: oppRole });
  },
  roleReset: () => set({ role: null, roleEmail: null }),
}));
